const ToggleRight = [
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  },
  [
    ["rect", { x: "1", y: "5", width: "22", height: "14", rx: "7", ry: "7" }],
    ["circle", { cx: "16", cy: "12", r: "3" }]
  ]
];

export default ToggleRight;
